import { Fragment } from "react";
import { tokenizeLinks } from "@/lib/linkify";

/** Render user text with URLs and bare domains as safe external links. */
export function Linkify({ text }: { text: string }) {
  return (
    <>
      {tokenizeLinks(text).map((tok, i) =>
        tok.type === "link" ? (
          <a
            key={i}
            href={tok.href}
            target="_blank"
            rel="noreferrer noopener"
            className="linkified"
          >
            {tok.value}
          </a>
        ) : (
          <Fragment key={i}>{tok.value}</Fragment>
        ),
      )}
    </>
  );
}
